module.exports = __webpack_public_path__ + "img/artboard.b6856bbc.png";